import React from "react";
import AgentTransactions from "../modules/Transactions/agent-transactions/AgentTransactions";

export default function AgentTransactionsPage() {
    return <AgentTransactions />;
}